module.exports = __webpack_public_path__ + "static/GreycliffCF-Regular-9638a51e8b3f08075ade4252a0d6d54c.otf";